<template>
    <login-form-position>
        <v-alert ref="auth-notice" v-model="anyNotice" dismissible type="success" class="elevation-12 shape cutie">
            {{ anyNoticeMessage }}
        </v-alert>
        <alert-error id="errorMessage" v-model="anyError" :title="anyErrorMessage" dismissible class="elevation-12" />
        <the-change-password-form :token="token" />
    </login-form-position>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { AlertError } from '../../atoms';
import type { UserState } from '../../../store/modules/user/types';
import type { AuthState } from '../../../store/modules/auth/types';
import TheChangePasswordForm from '../../organisms/auth/TheChangePasswordForm.vue';
import { LoginFormPosition } from '../../organisms';

@Component({
    components: {
        TheChangePasswordForm,
        LoginFormPosition,
        AlertError,
    },
})
export default class TheChangePasswordPage extends Vue {
    @State('user') user: UserState;
    @State('auth') auth: AuthState;
    @Action('dealError', { namespace: 'auth' }) authDealError;
    @Action('dealNotice', { namespace: 'auth' }) dealNotice;
    @Prop({ default: '' }) readonly token: string;

    /**
     * getter, setter
     */
    get authErrorMessage(): string {
        return `${this.auth.errorCode} - ${this.auth.errorMsg}`;
    }
    get embeddedErrorMessage(): string {
        return `${this.auth.embedded.errorCode} - ${this.auth.embedded.errorMsg}`;
    }
    get authError(): boolean {
        return this.auth.error;
    }
    get embeddedError(): boolean {
        return this.auth.embedded.error;
    }
    get anyError(): boolean {
        return this.authError || this.embeddedError || this.passwordChangeError;
    }
    set anyError(val) {
        if (this.authError || this.embeddedError) this.authDealError();
    }
    get anyErrorMessage(): string {
        if (this.authError) return this.authErrorMessage;
        if (this.embeddedError) return this.embeddedErrorMessage;
        if (this.passwordChangeError) return this.passwordChangeErrorMessage;
        return '';
    }
    set anyNotice(val) {
        if (this.auth.embedded.notice || this.auth.notice) this.dealNotice();
    }
    get anyNotice(): boolean {
        return !!this.anyNoticeMessage;
    }
    get anyNoticeMessage(): string {
        return this.auth.embedded.notice || this.auth.notice;
    }
    get passwordChangeErrorMessage(): string {
        return this.passwordChangeError
            ? `${this.user.update_password.errorDetails[0].code} - ${this.user.update_password.errorDetails[0].message}`
            : '';
    }
    get passwordChangeError(): boolean {
        return this.user.update_password.error;
    }
}
</script>
